import { Component } from '@angular/core';
import { Header } from '../../layout/header/header';
import { Sidebar } from '../../layout/sidebar/sidebar';
import { RouterOutlet } from '@angular/router';
import { CommonService } from '../../shared/services/common-service';

@Component({
  selector: 'app-landing-page',
  imports: [Header, Sidebar, RouterOutlet],
  templateUrl: './landing-page.html',
  styleUrl: './landing-page.scss',
  standalone: true,
})
export class LandingPage {
  constructor(private _commonService: CommonService) {}

  onHover(): void {
    // Open sidebar on hover - only if currently hidden
    if (this._commonService.sidebarHidden()) {
      this._commonService.openSidebar();
    }
  }

  onLeave(): void {
    // Close sidebar on leave - only if currently shown
    if (!this._commonService.sidebarHidden()) {
      this._commonService.closeSidebar();
    }
  }
}
